<template>
  <div class="box grow scrollable only-y customer-invoices " :style="getHeightStyle">
    <resize-observer @notify="__resizeHanlder" />
    <UnpaidCustomerInvoices :customerId="customerId" :showLink="false"></UnpaidCustomerInvoices>
    <h4>{{$t('customer_portal.My_billing_history')}}</h4>
    <el-table
      ref="historic"
      :data="invoices"
      style="width: 100%"
      :empty-text="$t('customer_portal.No_billing_history')"
      v-loading="loading"
      v-if="pageWidth>1024">
      <el-table-column type="expand">
        <template slot-scope="props">
          <h4><i class="mdi mdi-credit-card-multiple"></i> {{$t('customer_portal.Payments')}}</h4>
          <InvoicePaymentCard  v-for="payment in props.row.payments" :key="payment.id" :payment="payment"></InvoicePaymentCard>
        </template>
      </el-table-column>
      <el-table-column
        property="inv_number"
        :label="$t('customer_portal.Invoice_number')"
        sortable>
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" @click="downloadInvoiceReport(scope.row)">{{scope.row.inv_number}} <i class="mdi mdi-file-pdf"></i></el-link>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('customer_portal.Invoice_Date')"
        prop="date"
        sortable>
        <template slot-scope="scope">
          {{_moment(scope.row.date)}}
        </template>
      </el-table-column>
      <el-table-column
        property="due_date"
        :label="$t('customer_portal.Invoice_Due_date')"
        sortable>
        <template slot-scope="scope">
          {{_moment(scope.row.due_date)}}
        </template>
      </el-table-column>
      <el-table-column
        property="total"
        :label="$t('customer_portal.Invoice_Total_amount')"
        show-overflow-tooltip
        sortable>
        <template slot-scope="scope">
          {{$n(scope.row.total, 'currency')}}
        </template>
      </el-table-column>
      <el-table-column
        property="paid"
        :label="$t('customer_portal.Status')"
        sortable>
        <template slot-scope="scope">
          <el-tag  :type="getInvoiceTagType(scope.row)">{{$t("invoices.statuses."+scope.row.status.code)}}</el-tag>
        </template>
      </el-table-column>

    </el-table>
    <div v-else>
      <el-card shadow="hover" v-for="invoice in invoices" :key="invoice.id"  @click.native="showInvoiceDetail(invoice)" style="color:#4a596a;margin-bottom:10px;">
          <div style="height:130px">
            <div style="display:block;float:left;">
              <el-link type="primary" :underline="false" @click="downloadInvoiceReport(invoice)">
                <strong>{{invoice.inv_number}}</strong><i class="mdi mdi-file-pdf"></i>
              </el-link><br>
              <div v-if="pageWidth<500">
                <el-tag :type="getInvoiceTagType(invoice)" style="margin-top:10px;">{{$t("invoices.statuses."+invoice.status.code)}}</el-tag>
              </div>
              <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Date_of_issue_colon')}} {{_moment(invoice.date)}}</span><br>
              <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Due_date_colon')}} {{_moment(invoice.due_date)}}</span><br>
              <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Total_amount_colon')}} {{$n(invoice.total,'currency')}}</span>
            </div>
            <div v-if="pageWidth>=500" style="float:right">
              <el-tag :type="getInvoiceTagType(invoice)" style="margin-left:10px;">{{$t("invoices.statuses."+invoice.status.code)}}</el-tag>
            </div>
          </div>
          <div style="display:block;text-align:left;" v-if="selectedInvoiceId==invoice.id">
            <el-divider/>
            <h4><i class="mdi mdi-credit-card-multiple"></i> {{$t('customer_portal.Payments')}}</h4>
            <InvoicePaymentCard  v-for="payment in invoice.payments" :key="payment.id" :payment="payment"></InvoicePaymentCard>
          </div>
      </el-card>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapState, mapGetters } from 'vuex';
  import moment from 'moment-timezone'

  import CustomerInvoices from '@/components/invoice/customer-invoices.vue'
  import InvoicePaymentCard from '@/components/invoice/invoice-payment-card.vue'

  export default {
    name: 'Customer-invoices-list',
    props: {

  	},
    data() {
      return {
        pageWidth : 0,
        pageHeight : 0,
        selectedInvoiceId : null
      };
    },components: {
      CustomerInvoices,
      InvoicePaymentCard
    },
    watch : {

    },
  	methods: {
      showInvoiceDetail(invoice){
        this.selectedInvoiceId = this.selectedInvoiceId==invoice.id?null:invoice.id;
      },
      __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
      getHeightStyle(){
        return "height:" + (this.pageHeight-242) + "px;";
      },
      _moment(datetime, format='LL'){
        moment.locale(this.$i18n.locale);
        return moment(datetime).format(format);
      },
  		setPageWidth() {
  			this.pageWidth = document.getElementById('page-panel').offsetWidth;
  			this.pageHeight = document.getElementById('page-panel').offsetHeight;
  		},
      ...mapActions('invoices', ['changePage','fetchInvoices','downloadInvoiceReport'])

  	},
  	computed: {
      customerId(){
  			if(this.$store.getters.customerProfile){
  					return this.$store.getters.customerProfile.id;
  			}
  			return null;
  		},
      ...mapState('invoices', ['loading', 'invoices','page','pages','limit', 'count']),
      ...mapGetters('invoices',['getInvoiceTagType'])
  	},
    mounted(){
      this.fetchInvoices({customerId, statusCode:'PAID'});
      this.setPageWidth()
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';


  .active{
    background-color: lighten($background-color, 20%);
    border-radius: 5px;
    box-shadow:none;
    box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
  }


  .item-list {
    //margin: 0 auto;
    width: 100%;
    padding: 0px 30px;
    box-sizing: border-box;

    .item {
      margin: 10px 0;
      padding: 5px;
      box-sizing: border-box;
      cursor: pointer;
      transition: all .5s .25s;


      .info {
        word-break: break-word;

      }

      &:hover {
        //margin: 15px -20px;
        //padding: 10px;
        background-color: lighten($background-color, 20%);
        border-radius: 5px;
        box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

      }

    }
  }

  </style>
